(() => {
  angular
    .module('app.report')
    .controller('ProfileReportController', ProfileReport);

  ProfileReport.$inject = [
    '$q',
    '$scope',
    '$window',
    '$rootScope',
    '$filter',
    'Report',
    'Targetgroup',
    'ChartService',
    'CampaignService',
    'CustomSegmentsService',
    'CampaignManagerService'
  ];

  function ProfileReport(
    $q,
    $scope,
    $window,
    $rootScope,
    $filter,
    Report,
    Targetgroup,
    ChartService,
    CampaignService,
    CustomSegmentsService,
    CampaignManagerService
  ) {
    document.removeEventListener('visibilitychange', updateDataOnVisible);

    let isVisibilityWatcherSetted = false;
    let cache = {
      chart: {
        options: ChartService.getPieChartConfig(),
      },
    };
    const { report } = $scope.$parent;
    const vm = this;
    vm.common = {};
    vm.details = [];
    vm.categoryChartConfig = [];
    vm.segmentAvailable = {};

    vm.getReportItem = function (ri) {
      const { reportItems } = report.campaign;
      return reportItems.find(item => item.evid === ri.evid);
    };

    vm.isTVEnabled = function (reportItem) {
      const ri = this.getReportItem(reportItem);
      return ri && ri.properties.featureTVEnabled === 1;
    };

    vm.getProvider = provider => report.getProvider(provider);
    vm.isStandard = () => report.campaign && report.campaign.type === 'standard';
    vm.isYouTubeCampaign = () => report.campaign && report.campaign.sources.some(item => item.provider === 'adh');
    vm.canShow = name => !vm.isYouTubeCampaign() || ['age', 'gender'].includes(name);

    vm.getSampleSizeErrorLevel = reportItem => reportItem.nStatus;

    vm.getSampleSizeErrorTooltip = function (reportItem) {
      switch (this.getSampleSizeErrorLevel(reportItem)) {
        case 'warning': return `Sample size is ${reportItem.n}. That seems a bit low!`;
        case 'error': return 'No sample size - please check the implementation!';
        default: return `Sample size is ${$filter('number')(reportItem.n)}`;
      }
    };

    activate();
    function activate() {
      report.isCampaignLoading = true;
      report.subActivate = activate;

      report.profilePromise =  report.profilePromise || Report.getProfileData(report.campaignIdParam).$promise;
      report.targetPromise = report.targetPromise || Targetgroup.catNames(report.campaignIdParam).$promise;

      $q.all([
        report.profilePromise,
        report.targetPromise
      ]).then((response) => {
        const {
          profileAffinities,
          defaultSegments,
          customSegmentGroups,
          currencyCode,
        } = response[0].data;

        cache = {
          ...cache,
          currencyCode,
          profileAffinities,
          details: defaultSegments || [],
          customSegments: customSegmentGroups || [],
          catNames: response[1].data
        };

        vm.commonLoaded = true;
        vm.detailsLoaded = true;
      }).then(() => {
        report.isCampaignLoading = false;
        report.isCampaignLoaded = true;

        if (document.visibilityState === 'visible') {
          updateDataOnVisible();
        } else {
          if (!isVisibilityWatcherSetted) {
            document.addEventListener('visibilitychange', updateDataOnVisible);
            isVisibilityWatcherSetted = true;
          }
        }
      });
    }

    function updateDataOnVisible() {
      if (document.visibilityState !== 'visible') {
        return false;
      }

      if (vm.isStandard()) {
        vm.affinity = [{
          name: 'total',
          ...cache.profileAffinities,
        }];
      } else {
        const getFixedProviderId = providerId => {
          if (providerId === 'dv360' ||
              providerId === 'adwords') {
            return 'youtube';
          }

          return providerId;
        }

        const { age, gender } = cache.profileAffinities;
        if (!_.isUndefined(age) && !_.isUndefined(gender)) {
          vm.affinity = [{
            name: 'total',
            age,
            gender,
          }];

          const { reportItems } = cache.profileAffinities;
          if (reportItems && reportItems.length > 1) {
            reportItems.map(item => {
              vm.affinity.push({
                ...item.profileAffinities,
                name: getFixedProviderId(item.providerId),
              });
            });
          }
        }
      }

      vm.target = cache.catNames;
      vm.details = cache.details;
      vm.currency = cache.currencyCode;

      if (!vm.isStandard()) {
        vm.target['age'] = [
          [0, 18],
          [18, 24],
          [25, 34],
          [35, 44],
          [45, 54],
          [55, 64],
          [64, 99],
        ];
      }

      updateCustomSegments();
      updateAvailableSegments();
      updateCharts();
    }

    function updateCustomSegments() {
      if (angular.isUndefined(cache.customSegments)) {
        return false;
      }

      vm.customSegmentsGroups = cache.customSegments;
      vm.customSegmentsLoaded = true;

      vm.removeSegment = segment => {
        vm.campaignBusy = true;
        vm.customSegmentsGroups = vm.customSegmentsGroups.map(group => ({
          ...group,
          customSegments: group.customSegments.filter(item => item.csid !== segment.csid)
        }));

        const campaignData = CampaignManagerService.getCampaignData();
        const campaign = {
          ...campaignData,
          customSegments: campaignData.customSegments.filter(item => item.csid !== segment.csid)
        }
        delete campaign.targetSegment[segment.csid];

        const campaignSavePromise = CampaignService.update(campaign).$promise;
        campaignSavePromise.then(
          //on success
          response => {
            vm.campaignBusy = false;
            $window.location.reload();
          },
          //on failure
          response => {
            vm.campaignBusy = false;
            console.error(response.data.error);
          }
        );
      };
    }

    function updateAvailableSegments() {
      if (!vm.customSegmentsGroups) {
        return false;
      }

      vm.customSegmentsGroups.forEach(({ customSegments }) => {
        if (customSegments) {
          customSegments.forEach(segment => {
            const { csid } = segment;
            const { startDate, country } = report.campaign;
            vm.segmentAvailable[csid] = true;

            const promise = CustomSegmentsService.isAvailable({
              csid,
              startDate: startDate ? new Date(startDate) : new Date(),
              countryCode: country
            }).$promise;

            promise.then(({ data }) => {
              vm.segmentAvailable[csid] = data && data.available;
            });
          });
        }
      });
    }

    function updateCharts() {
      const getLabels = (details, index) => {
        if (vm.isStandard()) {
          return details.valueLabels[index];
        }

        return details.valueLabels[details.name][index];
      };

      vm.details.forEach(details => {
        const data = details.totals.percents.map((item, index) => ({
          y: item,
          name: getLabels(details, index),
          sliced: index === 0,
        }));

        details.hasData = data.some(item => item.y > 0);
        addChartConfig(details.name, data);
      });

      vm.customSegmentsGroups.forEach(({ customSegments }) => {
        if (customSegments) {
          customSegments.forEach(segment => {
            if (!segment.totals) {
              return true;
            }

            const data = segment.totals.percents.map((item, index) => ({
              y: item,
              name: segment.valueLabels[index],
              sliced: index === 0,
            }));

            segment.hasData = data.some(item => item.y > 0);
            addChartConfig(segment.csid, data);
          });
        }
      });
    }

    function addChartConfig(key, data) {
      vm.categoryChartConfig[key] = {
        ...cache.chart.options,
        series: [{
          colorByPoint: true,
          data,
        }],
      };
    }

    $scope.$watch(() => $rootScope.campaignBusy, busy => {
      if (!vm.campaignBusy) {
        vm.campaignBusy = busy;
      }
    }, true);
  }
})();
